
document.addEventListener("DOMContentLoaded", (event) => {
  setTimeout(() => {
    const isPdp = BSS_B2B.page.isProductPage()
    if (!isPdp) return;
    
    BSS_B2B?.observer?.productSubject?.notifyObserver?.('ProductMutate', 'ProductPriceMutate');
  }, 2000);
});